export { default } from "./WordStudyOrganizer";
